import {useUserStore} from "@/store/user";
import {Message} from "@arco-design/web-vue";
import router from "@/router";
import {useBaseDataStore} from "@/store/base-data-store";
import {useProjectServiceOrderStore, useProjectTaskDataStore} from "@/store/work-order-data";
import {useCustomerAccountStore, useCustomerStore, useCustomerStoreInfoStore} from "@/store/customer-data";
import {useSysDictDataStore, useSystemOptionsStore} from "@/store/system-data";
import {useUserDataStore} from "@/store/user-data";

const whiteList = ['/login', '/Console'];
function loadBaseData(next) {
    // 如果没有基础数据
    if (!useBaseDataStore().baseData) {
        console.log('permission#initData')
        initData().then(() => {
            next()
        })
    } else {
        next()
    }
}
router.beforeEach((to, from, next) => {
    // console.log('permission#beforeEach')
    if (to.path === '/login') {
        next()
    }else if (useUserStore().getToken) {
        /* 有token*/
        if(!useUserStore().userInfo.id){
            useUserStore().loadUserInfo().then(()=>{
                loadBaseData( next)
            })
        }else {
            loadBaseData( next)
        }
    } else {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            Message.error('登录已过期，请重新登录');
            next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
        }
    }
})

async function initData() {
    await useBaseDataStore().initBaseData()
    await useProjectTaskDataStore().initProjectTaskData()
    await useProjectServiceOrderStore().initProjectServiceOrderData()
    await useCustomerStore().initCustomerData()
    await useCustomerStoreInfoStore().initCustomerStoreData()
    await useCustomerAccountStore().initCustomerAccountData()
    await useSysDictDataStore().initSysDictData()
    await useSystemOptionsStore().initSystemOptions()
    await useUserDataStore().initUserData()
}